if (document.querySelectorAll('[data-fancybox="gallery"],[data-fancybox="pdp-description-image"], [data-fancybox="gallery-solitaire"]').length > 0) {
  Fancybox.bind('[data-fancybox="gallery"],[data-fancybox="pdp-description-image"],[data-fancybox="gallery-solitaire"],[data-fancybox^="gallery-variant-"]', {
    Thumbs: {
      type: "classic",
      showOnStart: false,
    },
    video: {
      autoStart: true,
      fullscreen: true
    },
    afterShow: function (instance, current) {
      const video = current.$content.find("video").get(0);
      if (video && video.requestFullscreen) {
        video.requestFullscreen();
      }
    }
  });
}
